import type { BaseDto } from '../base.dto';
import type { GenderDto } from '../clinical-details/gender.dto';
import type { DiagnosisGroupDto } from '../diagnoses/diagnosis-group.dto';
import type { DiagnosisDto } from '../diagnoses/diagnosis.dto';
import type { ConditionImageDto } from '../condition-info/condition-image.dtos';
import type { ModelViewerLocation } from '../model-viewer-location.dto';
import type { UserDto } from '../user.dto';
import type { PathologicalAssessmentDto } from './pathological-assessment.dtos';

export class ThinPathologicalAssessmentRequestDto implements BaseDto {
  id: string;
  createdByUser?: UserDto;
  updatedByUser?: UserDto;
  deletedByUser?: UserDto;
  age: number;
  gender: GenderDto;
  created?: string;
  updated?: string;
  deleted?: string;
  healthRecordId: string;
  preciseLocation?: ModelViewerLocation;
  conditionId?: string;
  /** @deprecated Use conditionId */
  lesionId?: string;
  dermoscopicImage: ConditionImageDto;
  clinicalDiagnosis: DiagnosisDto;
  clinicalDiagnosisGroups: DiagnosisGroupDto[];
  latestAssessment: PathologicalAssessmentDto;
}
